module.exports = __webpack_public_path__ + "house.da9105357cbfc605ce26e628a59b9a5a.svg";